import React from "react";
import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <div
      data-testid="loading-screen"
      className="fixed inset-0 z-[100] bg-[#FDFBF7] flex flex-col items-center justify-center"
    >
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-[11px] tracking-[0.3em] uppercase font-semibold text-stone-500"
      >
        Globezing
      </motion.p>
      <motion.h1
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.15 }}
        className="mt-4 font-serif text-3xl sm:text-4xl font-light italic text-stone-900"
      >
        Loading the archive…
      </motion.h1>
      <div className="mt-8 h-px w-40 bg-stone-300 overflow-hidden">
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: "100%" }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
          className="h-full w-1/2 bg-[#9c4122]"
        />
      </div>
    </div>
  );
}
